import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SynchronizationResolver } from '../utils/syncronization.resolver';
import { environment } from '../../environments/environment';
import { CustomersListPageComponent } from './pages/list/customers-list-page.component';
import { CustomerDetailPageComponent } from './pages/detail/customer-detail-page.component';
import { NewCustomerPageComponent } from './pages/new/new-customer.component';
import { EditCustomerPageComponent } from './pages/edit/edit-customer.component';
import { InspectionListPageComponent } from '../inspections/pages/list.component';

const routes: Routes = [
  {
    path: '',
    resolve: { synchronizeData: SynchronizationResolver },
    children: [
      { path: environment.applicationRoute + '/customers', component: CustomersListPageComponent },
      { path: environment.applicationRoute + '/customers/create', component: NewCustomerPageComponent },
      { path: environment.applicationRoute + '/customers/:clientNumber/edit', component: EditCustomerPageComponent },
      { path: environment.applicationRoute + '/customers/:clientNumber/inspections', component: InspectionListPageComponent },
      { path: environment.applicationRoute + '/customers/:clientNumber', component: CustomerDetailPageComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CustomersRoutingModule {}
